import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _381d0f36 = () => interopDefault(import('../client/pages/activity-contact/index.vue' /* webpackChunkName: "pages/activity-contact/index" */))
const _2528c97d = () => interopDefault(import('../client/pages/album-annual.vue' /* webpackChunkName: "pages/album-annual" */))
const _1e151a26 = () => interopDefault(import('../client/pages/album-download.vue' /* webpackChunkName: "pages/album-download" */))
const _3ba15d97 = () => interopDefault(import('../client/pages/app-point/index.vue' /* webpackChunkName: "pages/app-point/index" */))
const _22f3013d = () => interopDefault(import('../client/pages/bole-register/index.vue' /* webpackChunkName: "pages/bole-register/index" */))
const _1ab24992 = () => interopDefault(import('../client/pages/contribute-pr.vue' /* webpackChunkName: "pages/contribute-pr" */))
const _5522f965 = () => interopDefault(import('../client/pages/contribute-pr-new.vue' /* webpackChunkName: "pages/contribute-pr-new" */))
const _d6213b28 = () => interopDefault(import('../client/pages/contribute-pr-old.vue' /* webpackChunkName: "pages/contribute-pr-old" */))
const _b45374ca = () => interopDefault(import('../client/pages/course.vue' /* webpackChunkName: "pages/course" */))
const _afb38c1a = () => interopDefault(import('../client/pages/course-detail.vue' /* webpackChunkName: "pages/course-detail" */))
const _547c828a = () => interopDefault(import('../client/pages/crowdsource/index.vue' /* webpackChunkName: "pages/crowdsource/index" */))
const _237a6d66 = () => interopDefault(import('../client/pages/douyin-push/index.vue' /* webpackChunkName: "pages/douyin-push/index" */))
const _bef34990 = () => interopDefault(import('../client/pages/error.vue' /* webpackChunkName: "pages/error" */))
const _10f7ae43 = () => interopDefault(import('../client/pages/event-work-asyn/index.vue' /* webpackChunkName: "pages/event-work-asyn/index" */))
const _4b60a310 = () => interopDefault(import('../client/pages/festival.vue' /* webpackChunkName: "pages/festival" */))
const _d1b7f97e = () => interopDefault(import('../client/pages/following.vue' /* webpackChunkName: "pages/following" */))
const _f7315b42 = () => interopDefault(import('../client/pages/home.vue' /* webpackChunkName: "pages/home" */))
const _67dc0d62 = () => interopDefault(import('../client/pages/Invite-new-users-bole/index.vue' /* webpackChunkName: "pages/Invite-new-users-bole/index" */))
const _559c2c85 = () => interopDefault(import('../client/pages/photo-movie.vue' /* webpackChunkName: "pages/photo-movie" */))
const _7647844c = () => interopDefault(import('../client/pages/photographer/index.vue' /* webpackChunkName: "pages/photographer/index" */))
const _705aa732 = () => interopDefault(import('../client/pages/policy.vue' /* webpackChunkName: "pages/policy" */))
const _62fda4c0 = () => interopDefault(import('../client/pages/post.vue' /* webpackChunkName: "pages/post" */))
const _7fcbf398 = () => interopDefault(import('../client/pages/protocol.vue' /* webpackChunkName: "pages/protocol" */))
const _2805726a = () => interopDefault(import('../client/pages/rankboard.vue' /* webpackChunkName: "pages/rankboard" */))
const _3b923d5a = () => interopDefault(import('../client/pages/showToast.vue' /* webpackChunkName: "pages/showToast" */))
const _95da630a = () => interopDefault(import('../client/pages/tag-manage/index.vue' /* webpackChunkName: "pages/tag-manage/index" */))
const _0956539a = () => interopDefault(import('../client/pages/video-authorization/index.vue' /* webpackChunkName: "pages/video-authorization/index" */))
const _09092174 = () => interopDefault(import('../client/pages/withdraw-rules.vue' /* webpackChunkName: "pages/withdraw-rules" */))
const _77e3efe2 = () => interopDefault(import('../client/pages/yintu.vue' /* webpackChunkName: "pages/yintu" */))
const _49f4fda1 = () => interopDefault(import('../client/pages/yintu-share.vue' /* webpackChunkName: "pages/yintu-share" */))
const _f5b87468 = () => interopDefault(import('../client/pages/activity-contact/content.vue' /* webpackChunkName: "pages/activity-contact/content" */))
const _9d1387fe = () => interopDefault(import('../client/pages/activity-contact/form.vue' /* webpackChunkName: "pages/activity-contact/form" */))
const _33981fec = () => interopDefault(import('../client/pages/activity-contact/header.vue' /* webpackChunkName: "pages/activity-contact/header" */))
const _42239480 = () => interopDefault(import('../client/pages/activity-contact/jsBridge.js' /* webpackChunkName: "pages/activity-contact/jsBridge" */))
const _f3fb432a = () => interopDefault(import('../client/pages/activity-contact/jump.vue' /* webpackChunkName: "pages/activity-contact/jump" */))
const _2d0a9a05 = () => interopDefault(import('../client/pages/activity-contact/scroll.js' /* webpackChunkName: "pages/activity-contact/scroll" */))
const _26f68c1e = () => interopDefault(import('../client/pages/contribute/home.vue' /* webpackChunkName: "pages/contribute/home" */))
const _43cd24a8 = () => interopDefault(import('../client/pages/contribute/introduction.vue' /* webpackChunkName: "pages/contribute/introduction" */))
const _cfd0355a = () => interopDefault(import('../client/pages/contribute/unauth.vue' /* webpackChunkName: "pages/contribute/unauth" */))
const _314069da = () => interopDefault(import('../client/pages/crowdsource/example.vue' /* webpackChunkName: "pages/crowdsource/example" */))
const _b65f0c0a = () => interopDefault(import('../client/pages/crowdsource/finalist.vue' /* webpackChunkName: "pages/crowdsource/finalist" */))
const _13e36372 = () => interopDefault(import('../client/pages/crowdsource/finalitem.vue' /* webpackChunkName: "pages/crowdsource/finalitem" */))
const _2e6c7474 = () => interopDefault(import('../client/pages/crowdsource/header.vue' /* webpackChunkName: "pages/crowdsource/header" */))
const _20300051 = () => interopDefault(import('../client/pages/crowdsource/join.vue' /* webpackChunkName: "pages/crowdsource/join" */))
const _c47382d4 = () => interopDefault(import('../client/pages/crowdsource/jsBridge.js' /* webpackChunkName: "pages/crowdsource/jsBridge" */))
const _59f86472 = () => interopDefault(import('../client/pages/crowdsource/method.js' /* webpackChunkName: "pages/crowdsource/method" */))
const _bd82fdba = () => interopDefault(import('../client/pages/crowdsource/rule.vue' /* webpackChunkName: "pages/crowdsource/rule" */))
const _5b4ab32c = () => interopDefault(import('../client/pages/crowdsource/task.vue' /* webpackChunkName: "pages/crowdsource/task" */))
const _0449bc6a = () => interopDefault(import('../client/pages/delete-account/apply.vue' /* webpackChunkName: "pages/delete-account/apply" */))
const _48f94488 = () => interopDefault(import('../client/pages/delete-account/confirm.vue' /* webpackChunkName: "pages/delete-account/confirm" */))
const _44a715ad = () => interopDefault(import('../client/pages/delete-account/verify.vue' /* webpackChunkName: "pages/delete-account/verify" */))
const _793c040b = () => interopDefault(import('../client/pages/douyin-push/auth-button.vue' /* webpackChunkName: "pages/douyin-push/auth-button" */))
const _b032a39a = () => interopDefault(import('../client/pages/douyin-push/bind-toast.vue' /* webpackChunkName: "pages/douyin-push/bind-toast" */))
const _36da1f8c = () => interopDefault(import('../client/pages/douyin-push/close.vue' /* webpackChunkName: "pages/douyin-push/close" */))
const _53799c18 = () => interopDefault(import('../client/pages/douyin-push/notice.vue' /* webpackChunkName: "pages/douyin-push/notice" */))
const _28ad3131 = () => interopDefault(import('../client/pages/douyin-push/post-card.vue' /* webpackChunkName: "pages/douyin-push/post-card" */))
const _795fefbf = () => interopDefault(import('../client/pages/douyin-push/post-list.vue' /* webpackChunkName: "pages/douyin-push/post-list" */))
const _62eb29b0 = () => interopDefault(import('../client/pages/event-work-asyn/auth-button.vue' /* webpackChunkName: "pages/event-work-asyn/auth-button" */))
const _bc9688e4 = () => interopDefault(import('../client/pages/event-work-asyn/post-card.vue' /* webpackChunkName: "pages/event-work-asyn/post-card" */))
const _1b310bc8 = () => interopDefault(import('../client/pages/event-work-asyn/post-list.vue' /* webpackChunkName: "pages/event-work-asyn/post-list" */))
const _ac2863e2 = () => interopDefault(import('../client/pages/feedback/faq/index.vue' /* webpackChunkName: "pages/feedback/faq/index" */))
const _3194030d = () => interopDefault(import('../client/pages/feedback/history/index.vue' /* webpackChunkName: "pages/feedback/history/index" */))
const _45566b1b = () => interopDefault(import('../client/pages/feedback/hot-list/index.vue' /* webpackChunkName: "pages/feedback/hot-list/index" */))
const _69ad1bd9 = () => interopDefault(import('../client/pages/height-Quality-picture/picture.vue' /* webpackChunkName: "pages/height-Quality-picture/picture" */))
const _39067caa = () => interopDefault(import('../client/pages/Invite-new-users-bole/canvas.vue' /* webpackChunkName: "pages/Invite-new-users-bole/canvas" */))
const _74c10d77 = () => interopDefault(import('../client/pages/Invite-new-users-bole/canvasImageFunction.js' /* webpackChunkName: "pages/Invite-new-users-bole/canvasImageFunction" */))
const _f91943ba = () => interopDefault(import('../client/pages/Invite-new-users-bole/card.vue' /* webpackChunkName: "pages/Invite-new-users-bole/card" */))
const _4f6b5d7c = () => interopDefault(import('../client/pages/Invite-new-users-bole/income.vue' /* webpackChunkName: "pages/Invite-new-users-bole/income" */))
const _07a41afe = () => interopDefault(import('../client/pages/Invite-new-users-bole/progressList.vue' /* webpackChunkName: "pages/Invite-new-users-bole/progressList" */))
const _76cfe30e = () => interopDefault(import('../client/pages/Invite-new-users-bole/question.vue' /* webpackChunkName: "pages/Invite-new-users-bole/question" */))
const _9d1ab7e2 = () => interopDefault(import('../client/pages/Invite-new-users-bole/rule.vue' /* webpackChunkName: "pages/Invite-new-users-bole/rule" */))
const _558c70ff = () => interopDefault(import('../client/pages/Invite-new-users-bole/rule-detail.vue' /* webpackChunkName: "pages/Invite-new-users-bole/rule-detail" */))
const _c4305c48 = () => interopDefault(import('../client/pages/Invite-new-users-bole/share.vue' /* webpackChunkName: "pages/Invite-new-users-bole/share" */))
const _d63c0c86 = () => interopDefault(import('../client/pages/Invite-new-users-bole/swiper-user.vue' /* webpackChunkName: "pages/Invite-new-users-bole/swiper-user" */))
const _1d6c87c8 = () => interopDefault(import('../client/pages/Invite-new-users-bole/userList.vue' /* webpackChunkName: "pages/Invite-new-users-bole/userList" */))
const _4733aaac = () => interopDefault(import('../client/pages/medal/detail/index.vue' /* webpackChunkName: "pages/medal/detail/index" */))
const _02c526b9 = () => interopDefault(import('../client/pages/medal/list/index.vue' /* webpackChunkName: "pages/medal/list/index" */))
const _0d72b23a = () => interopDefault(import('../client/pages/photographer/business-card/index.vue' /* webpackChunkName: "pages/photographer/business-card/index" */))
const _2f5a2c68 = () => interopDefault(import('../client/pages/tag-manage/activity-manage.vue' /* webpackChunkName: "pages/tag-manage/activity-manage" */))
const _55451243 = () => interopDefault(import('../client/pages/tag-manage/batch-collect/index.vue' /* webpackChunkName: "pages/tag-manage/batch-collect/index" */))
const _4c22445e = () => interopDefault(import('../client/pages/tag-manage/batch-remove.vue' /* webpackChunkName: "pages/tag-manage/batch-remove" */))
const _7cafcd1e = () => interopDefault(import('../client/pages/tag-manage/edit.vue' /* webpackChunkName: "pages/tag-manage/edit" */))
const _3a3dff20 = () => interopDefault(import('../client/pages/tag-manage/selection-manage/index.vue' /* webpackChunkName: "pages/tag-manage/selection-manage/index" */))
const _32511982 = () => interopDefault(import('../client/pages/video-authorization/auth-button.vue' /* webpackChunkName: "pages/video-authorization/auth-button" */))
const _a837db80 = () => interopDefault(import('../client/pages/video-authorization/notice.vue' /* webpackChunkName: "pages/video-authorization/notice" */))
const _234308ec = () => interopDefault(import('../client/pages/video-authorization/video-card.vue' /* webpackChunkName: "pages/video-authorization/video-card" */))
const _3f113a18 = () => interopDefault(import('../client/pages/video-authorization/video-list.vue' /* webpackChunkName: "pages/video-authorization/video-list" */))
const _d9e2ae64 = () => interopDefault(import('../client/pages/activity-contact/components/input.vue' /* webpackChunkName: "pages/activity-contact/components/input" */))
const _16058efe = () => interopDefault(import('../client/pages/activity-contact/components/star.vue' /* webpackChunkName: "pages/activity-contact/components/star" */))
const _d26a3c34 = () => interopDefault(import('../client/pages/activity-contact/components/textarea.vue' /* webpackChunkName: "pages/activity-contact/components/textarea" */))
const _5ccba522 = () => interopDefault(import('../client/pages/app-point/components/ad-coins-dialog.vue' /* webpackChunkName: "pages/app-point/components/ad-coins-dialog" */))
const _3fc95026 = () => interopDefault(import('../client/pages/app-point/components/dialog.vue' /* webpackChunkName: "pages/app-point/components/dialog" */))
const _26b96d72 = () => interopDefault(import('../client/pages/app-point/components/floating-icon.vue' /* webpackChunkName: "pages/app-point/components/floating-icon" */))
const _7da43412 = () => interopDefault(import('../client/pages/app-point/components/switch.vue' /* webpackChunkName: "pages/app-point/components/switch" */))
const _79acf0d4 = () => interopDefault(import('../client/pages/app-point/components/tips.vue' /* webpackChunkName: "pages/app-point/components/tips" */))
const _63131374 = () => interopDefault(import('../client/pages/crowdsource/components/check-box.vue' /* webpackChunkName: "pages/crowdsource/components/check-box" */))
const _05a3efe6 = () => interopDefault(import('../client/pages/crowdsource/components/close.vue' /* webpackChunkName: "pages/crowdsource/components/close" */))
const _647a368a = () => interopDefault(import('../client/pages/crowdsource/components/empty.vue' /* webpackChunkName: "pages/crowdsource/components/empty" */))
const _99d0b494 = () => interopDefault(import('../client/pages/crowdsource/components/play.vue' /* webpackChunkName: "pages/crowdsource/components/play" */))
const _4250acef = () => interopDefault(import('../client/pages/crowdsource/components/ruleDetail.vue' /* webpackChunkName: "pages/crowdsource/components/ruleDetail" */))
const _b9cdf774 = () => interopDefault(import('../client/pages/crowdsource/components/title.vue' /* webpackChunkName: "pages/crowdsource/components/title" */))
const _6d904a4a = () => interopDefault(import('../client/pages/crowdsource/components/verified.vue' /* webpackChunkName: "pages/crowdsource/components/verified" */))
const _630e4f62 = () => interopDefault(import('../client/pages/medal/components/mymedalbtn.vue' /* webpackChunkName: "pages/medal/components/mymedalbtn" */))
const _43971b0a = () => interopDefault(import('../client/pages/medal/components/userInfo.vue' /* webpackChunkName: "pages/medal/components/userInfo" */))
const _6496151c = () => interopDefault(import('../client/pages/medal/list/medalList.vue' /* webpackChunkName: "pages/medal/list/medalList" */))
const _1fb97298 = () => interopDefault(import('../client/pages/static-view/info/infringement.vue' /* webpackChunkName: "pages/static-view/info/infringement" */))
const _67d89a3f = () => interopDefault(import('../client/pages/tag-manage/selection-manage/add.vue' /* webpackChunkName: "pages/tag-manage/selection-manage/add" */))
const _11921d23 = () => interopDefault(import('../client/pages/tag-manage/selection-manage/detail.vue' /* webpackChunkName: "pages/tag-manage/selection-manage/detail" */))
const _d2966bac = () => interopDefault(import('../client/pages/tag-manage/selection-manage/set-cover.vue' /* webpackChunkName: "pages/tag-manage/selection-manage/set-cover" */))
const _76f4a0e8 = () => interopDefault(import('../client/pages/tag-manage/selection-manage/set-name.vue' /* webpackChunkName: "pages/tag-manage/selection-manage/set-name" */))
const _d38ae524 = () => interopDefault(import('../client/pages/tag-manage/selection-manage/setting.vue' /* webpackChunkName: "pages/tag-manage/selection-manage/setting" */))
const _b2d8bc56 = () => interopDefault(import('../client/pages/event-collect/_id/index.vue' /* webpackChunkName: "pages/event-collect/_id/index" */))
const _079d8ccc = () => interopDefault(import('../client/pages/draft/_businessLine/_draftName/index.vue' /* webpackChunkName: "pages/draft/_businessLine/_draftName/index" */))
const _5cc03d02 = () => interopDefault(import('../client/pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/activity-contact",
    component: _381d0f36,
    name: "activity-contact"
  }, {
    path: "/album-annual",
    component: _2528c97d,
    name: "album-annual"
  }, {
    path: "/album-download",
    component: _1e151a26,
    name: "album-download"
  }, {
    path: "/app-point",
    component: _3ba15d97,
    name: "app-point"
  }, {
    path: "/bole-register",
    component: _22f3013d,
    name: "bole-register"
  }, {
    path: "/contribute-pr",
    component: _1ab24992,
    name: "contribute-pr"
  }, {
    path: "/contribute-pr-new",
    component: _5522f965,
    name: "contribute-pr-new"
  }, {
    path: "/contribute-pr-old",
    component: _d6213b28,
    name: "contribute-pr-old"
  }, {
    path: "/course",
    component: _b45374ca,
    name: "course"
  }, {
    path: "/course-detail",
    component: _afb38c1a,
    name: "course-detail"
  }, {
    path: "/crowdsource",
    component: _547c828a,
    name: "crowdsource"
  }, {
    path: "/douyin-push",
    component: _237a6d66,
    name: "douyin-push"
  }, {
    path: "/error",
    component: _bef34990,
    name: "error"
  }, {
    path: "/event-work-asyn",
    component: _10f7ae43,
    name: "event-work-asyn"
  }, {
    path: "/festival",
    component: _4b60a310,
    name: "festival"
  }, {
    path: "/following",
    component: _d1b7f97e,
    name: "following"
  }, {
    path: "/home",
    component: _f7315b42,
    name: "home"
  }, {
    path: "/Invite-new-users-bole",
    component: _67dc0d62,
    name: "Invite-new-users-bole"
  }, {
    path: "/photo-movie",
    component: _559c2c85,
    name: "photo-movie"
  }, {
    path: "/photographer",
    component: _7647844c,
    name: "photographer"
  }, {
    path: "/policy",
    component: _705aa732,
    name: "policy"
  }, {
    path: "/post",
    component: _62fda4c0,
    name: "post"
  }, {
    path: "/protocol",
    component: _7fcbf398,
    name: "protocol"
  }, {
    path: "/rankboard",
    component: _2805726a,
    name: "rankboard"
  }, {
    path: "/showToast",
    component: _3b923d5a,
    name: "showToast"
  }, {
    path: "/tag-manage",
    component: _95da630a,
    name: "tag-manage"
  }, {
    path: "/video-authorization",
    component: _0956539a,
    name: "video-authorization"
  }, {
    path: "/withdraw-rules",
    component: _09092174,
    name: "withdraw-rules"
  }, {
    path: "/yintu",
    component: _77e3efe2,
    name: "yintu"
  }, {
    path: "/yintu-share",
    component: _49f4fda1,
    name: "yintu-share"
  }, {
    path: "/activity-contact/content",
    component: _f5b87468,
    name: "activity-contact-content"
  }, {
    path: "/activity-contact/form",
    component: _9d1387fe,
    name: "activity-contact-form"
  }, {
    path: "/activity-contact/header",
    component: _33981fec,
    name: "activity-contact-header"
  }, {
    path: "/activity-contact/jsBridge",
    component: _42239480,
    name: "activity-contact-jsBridge"
  }, {
    path: "/activity-contact/jump",
    component: _f3fb432a,
    name: "activity-contact-jump"
  }, {
    path: "/activity-contact/scroll",
    component: _2d0a9a05,
    name: "activity-contact-scroll"
  }, {
    path: "/contribute/home",
    component: _26f68c1e,
    name: "contribute-home"
  }, {
    path: "/contribute/introduction",
    component: _43cd24a8,
    name: "contribute-introduction"
  }, {
    path: "/contribute/unauth",
    component: _cfd0355a,
    name: "contribute-unauth"
  }, {
    path: "/crowdsource/example",
    component: _314069da,
    name: "crowdsource-example"
  }, {
    path: "/crowdsource/finalist",
    component: _b65f0c0a,
    name: "crowdsource-finalist"
  }, {
    path: "/crowdsource/finalitem",
    component: _13e36372,
    name: "crowdsource-finalitem"
  }, {
    path: "/crowdsource/header",
    component: _2e6c7474,
    name: "crowdsource-header"
  }, {
    path: "/crowdsource/join",
    component: _20300051,
    name: "crowdsource-join"
  }, {
    path: "/crowdsource/jsBridge",
    component: _c47382d4,
    name: "crowdsource-jsBridge"
  }, {
    path: "/crowdsource/method",
    component: _59f86472,
    name: "crowdsource-method"
  }, {
    path: "/crowdsource/rule",
    component: _bd82fdba,
    name: "crowdsource-rule"
  }, {
    path: "/crowdsource/task",
    component: _5b4ab32c,
    name: "crowdsource-task"
  }, {
    path: "/delete-account/apply",
    component: _0449bc6a,
    name: "delete-account-apply"
  }, {
    path: "/delete-account/confirm",
    component: _48f94488,
    name: "delete-account-confirm"
  }, {
    path: "/delete-account/verify",
    component: _44a715ad,
    name: "delete-account-verify"
  }, {
    path: "/douyin-push/auth-button",
    component: _793c040b,
    name: "douyin-push-auth-button"
  }, {
    path: "/douyin-push/bind-toast",
    component: _b032a39a,
    name: "douyin-push-bind-toast"
  }, {
    path: "/douyin-push/close",
    component: _36da1f8c,
    name: "douyin-push-close"
  }, {
    path: "/douyin-push/notice",
    component: _53799c18,
    name: "douyin-push-notice"
  }, {
    path: "/douyin-push/post-card",
    component: _28ad3131,
    name: "douyin-push-post-card"
  }, {
    path: "/douyin-push/post-list",
    component: _795fefbf,
    name: "douyin-push-post-list"
  }, {
    path: "/event-work-asyn/auth-button",
    component: _62eb29b0,
    name: "event-work-asyn-auth-button"
  }, {
    path: "/event-work-asyn/post-card",
    component: _bc9688e4,
    name: "event-work-asyn-post-card"
  }, {
    path: "/event-work-asyn/post-list",
    component: _1b310bc8,
    name: "event-work-asyn-post-list"
  }, {
    path: "/feedback/faq",
    component: _ac2863e2,
    name: "feedback-faq"
  }, {
    path: "/feedback/history",
    component: _3194030d,
    name: "feedback-history"
  }, {
    path: "/feedback/hot-list",
    component: _45566b1b,
    name: "feedback-hot-list"
  }, {
    path: "/height-Quality-picture/picture",
    component: _69ad1bd9,
    name: "height-Quality-picture-picture"
  }, {
    path: "/Invite-new-users-bole/canvas",
    component: _39067caa,
    name: "Invite-new-users-bole-canvas"
  }, {
    path: "/Invite-new-users-bole/canvasImageFunction",
    component: _74c10d77,
    name: "Invite-new-users-bole-canvasImageFunction"
  }, {
    path: "/Invite-new-users-bole/card",
    component: _f91943ba,
    name: "Invite-new-users-bole-card"
  }, {
    path: "/Invite-new-users-bole/income",
    component: _4f6b5d7c,
    name: "Invite-new-users-bole-income"
  }, {
    path: "/Invite-new-users-bole/progressList",
    component: _07a41afe,
    name: "Invite-new-users-bole-progressList"
  }, {
    path: "/Invite-new-users-bole/question",
    component: _76cfe30e,
    name: "Invite-new-users-bole-question"
  }, {
    path: "/Invite-new-users-bole/rule",
    component: _9d1ab7e2,
    name: "Invite-new-users-bole-rule"
  }, {
    path: "/Invite-new-users-bole/rule-detail",
    component: _558c70ff,
    name: "Invite-new-users-bole-rule-detail"
  }, {
    path: "/Invite-new-users-bole/share",
    component: _c4305c48,
    name: "Invite-new-users-bole-share"
  }, {
    path: "/Invite-new-users-bole/swiper-user",
    component: _d63c0c86,
    name: "Invite-new-users-bole-swiper-user"
  }, {
    path: "/Invite-new-users-bole/userList",
    component: _1d6c87c8,
    name: "Invite-new-users-bole-userList"
  }, {
    path: "/medal/detail",
    component: _4733aaac,
    name: "medal-detail"
  }, {
    path: "/medal/list",
    component: _02c526b9,
    name: "medal-list"
  }, {
    path: "/photographer/business-card",
    component: _0d72b23a,
    name: "photographer-business-card"
  }, {
    path: "/tag-manage/activity-manage",
    component: _2f5a2c68,
    name: "tag-manage-activity-manage"
  }, {
    path: "/tag-manage/batch-collect",
    component: _55451243,
    name: "tag-manage-batch-collect"
  }, {
    path: "/tag-manage/batch-remove",
    component: _4c22445e,
    name: "tag-manage-batch-remove"
  }, {
    path: "/tag-manage/edit",
    component: _7cafcd1e,
    name: "tag-manage-edit"
  }, {
    path: "/tag-manage/selection-manage",
    component: _3a3dff20,
    name: "tag-manage-selection-manage"
  }, {
    path: "/video-authorization/auth-button",
    component: _32511982,
    name: "video-authorization-auth-button"
  }, {
    path: "/video-authorization/notice",
    component: _a837db80,
    name: "video-authorization-notice"
  }, {
    path: "/video-authorization/video-card",
    component: _234308ec,
    name: "video-authorization-video-card"
  }, {
    path: "/video-authorization/video-list",
    component: _3f113a18,
    name: "video-authorization-video-list"
  }, {
    path: "/activity-contact/components/input",
    component: _d9e2ae64,
    name: "activity-contact-components-input"
  }, {
    path: "/activity-contact/components/star",
    component: _16058efe,
    name: "activity-contact-components-star"
  }, {
    path: "/activity-contact/components/textarea",
    component: _d26a3c34,
    name: "activity-contact-components-textarea"
  }, {
    path: "/app-point/components/ad-coins-dialog",
    component: _5ccba522,
    name: "app-point-components-ad-coins-dialog"
  }, {
    path: "/app-point/components/dialog",
    component: _3fc95026,
    name: "app-point-components-dialog"
  }, {
    path: "/app-point/components/floating-icon",
    component: _26b96d72,
    name: "app-point-components-floating-icon"
  }, {
    path: "/app-point/components/switch",
    component: _7da43412,
    name: "app-point-components-switch"
  }, {
    path: "/app-point/components/tips",
    component: _79acf0d4,
    name: "app-point-components-tips"
  }, {
    path: "/crowdsource/components/check-box",
    component: _63131374,
    name: "crowdsource-components-check-box"
  }, {
    path: "/crowdsource/components/close",
    component: _05a3efe6,
    name: "crowdsource-components-close"
  }, {
    path: "/crowdsource/components/empty",
    component: _647a368a,
    name: "crowdsource-components-empty"
  }, {
    path: "/crowdsource/components/play",
    component: _99d0b494,
    name: "crowdsource-components-play"
  }, {
    path: "/crowdsource/components/ruleDetail",
    component: _4250acef,
    name: "crowdsource-components-ruleDetail"
  }, {
    path: "/crowdsource/components/title",
    component: _b9cdf774,
    name: "crowdsource-components-title"
  }, {
    path: "/crowdsource/components/verified",
    component: _6d904a4a,
    name: "crowdsource-components-verified"
  }, {
    path: "/medal/components/mymedalbtn",
    component: _630e4f62,
    name: "medal-components-mymedalbtn"
  }, {
    path: "/medal/components/userInfo",
    component: _43971b0a,
    name: "medal-components-userInfo"
  }, {
    path: "/medal/list/medalList",
    component: _6496151c,
    name: "medal-list-medalList"
  }, {
    path: "/static-view/info/infringement",
    component: _1fb97298,
    name: "static-view-info-infringement"
  }, {
    path: "/tag-manage/selection-manage/add",
    component: _67d89a3f,
    name: "tag-manage-selection-manage-add"
  }, {
    path: "/tag-manage/selection-manage/detail",
    component: _11921d23,
    name: "tag-manage-selection-manage-detail"
  }, {
    path: "/tag-manage/selection-manage/set-cover",
    component: _d2966bac,
    name: "tag-manage-selection-manage-set-cover"
  }, {
    path: "/tag-manage/selection-manage/set-name",
    component: _76f4a0e8,
    name: "tag-manage-selection-manage-set-name"
  }, {
    path: "/tag-manage/selection-manage/setting",
    component: _d38ae524,
    name: "tag-manage-selection-manage-setting"
  }, {
    path: "/event-collect/:id?",
    component: _b2d8bc56,
    name: "event-collect-id"
  }, {
    path: "/draft/:businessLine?/:draftName?",
    component: _079d8ccc,
    name: "draft-businessLine-draftName"
  }, {
    path: "/",
    component: _5cc03d02,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
